import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { company } from "@/lib/branding";

/** Terminal page shown after a QUOTE-REQUEST signup (dumpster / roll-off).
 *  Standard credit-card signups skip this and go straight to Stripe. */
export default function SignupThanks() {
    const [params] = useSearchParams();
    const isQuote = params.get("type") === "quote";
    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="signup-thanks-page">
            <div className="max-w-md w-full text-center space-y-5">
                <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 flex items-center justify-center">
                    <CheckCircle2 className="w-8 h-8 text-emerald-600" />
                </div>
                <div>
                    <h1 className="font-heading text-3xl font-bold tracking-tight">
                        {isQuote ? "Quote request received" : "You're all set"}
                    </h1>
                    <p className="text-sm text-muted-foreground mt-3">
                        {isQuote
                            ? "Our team will follow up within one business day with pricing and availability. No charge until you approve the quote."
                            : "Thanks for signing up. Watch your inbox for a welcome email and your first pickup date."}
                    </p>
                </div>
                <div className="pt-4">
                    <Link to="/">
                        <Button variant="outline" data-testid="signup-thanks-home-btn">
                            Back to {company()}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
